<template>
    <div class="flex flex-col gap-5">
      <div class="text-start">
        <p class="text-xl md:text-2xl font-semibold">Confirm Cancellation</p>
        <p class="text-sm md:text-base text-[#626363] my-2">Are you sure you’d like to cancel this order?</p>
      </div>
      <div class="flex flex-col gap-5">
        <div class="inline-flex gap-12">
          <div class="w-1/2">
            <UButton size="xl" label="NO" variant="outline" block @click="handleClose"/>
          </div>
          <div class="w-1/2">
            <UButton size="xl" label="cancel order" block @click="CancelOrder" :loading="isLoading"/>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { V3ModalComponent } from '#components';
  import { V3PopupComponent } from '#components';
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';
  const { isMobile } = useDevice();
  const modal = useModal();
  const slideover = useSlideover();
  const cancelListener = ref(null);
  const isLoading = ref(false);
  const error = ref(false);
  const emit = defineEmits(['success', 'close']);
  const props = defineProps(['data']);
  const result = ref(null);
  const listenerTimeout = 10000;
  
  const CancelOrder = async () => {
    GoogleAnalytics.popUpClick({
      [EventParameter.POP_UP_NAME]: 'confirm_cancellation',
      [EventParameter.POP_UP_TITLE]: 'Are you sure you’d like to cancel this order?',
      [EventParameter.POP_UP_CTA_NAME]: 'cancel_order',
      [EventParameter.ORDER_ID]: props.data.order_id
    });
    const type = 'full'
    try {
      error.value = false;
      isLoading.value = true;
      const response = await useAPIHandler('post', `/orders/${props.data.order_id}/cancel`, { 
        body: { 
          type: 'full', 
          code: props.data.selectedValue  
        },
        auth: true 
      });
      const messageId = response.data.message_id;
      
      cancelListener.value = setInterval(async () => { 
        await responseListener(messageId, type === 'full' ? 'on_cancel' : 'on_update'); 
      }, 2000);
      
      setTimeout(function () {
          stopCancelListener();
      }, listenerTimeout);

    } catch (err) {
      isLoading.value = false;
      console.log("err", err);
      handleError()
    } 
  };

const handleError = () =>{
    emit('close');
    const message = 'Cancellation is not available now. Please try later';
    const component = isMobile ? V3PopupComponent : V3ModalComponent;
    if(isMobile){
      slideover.open(component, {
        component: 'error',
        data: { message },
        onClose: slideover.close
      });
    }else{
      modal.open(component, {
        component: 'error',
        data: { message },
        onClose: modal.close
      });
    }

}

const handleClose = () => {
  GoogleAnalytics.popUpClick({
    [EventParameter.POP_UP_NAME]: 'confirm_cancellation',
    [EventParameter.POP_UP_TITLE]: 'Are you sure you’d like to cancel this order?',
    [EventParameter.POP_UP_CTA_NAME]: 'no',
    [EventParameter.ORDER_ID]: props.data.order_id
  });
  emit('close');
};

const stopCancelListener = () => {
  isLoading.value = false
  if(result.value === null){
    handleError();
  }
  clearInterval(cancelListener.value);
};

const responseListener = async (messageId, action) => {
  try {
    const apiResult = await useAPIHandler('get', `/transactions?message_id=${messageId}&action=${action}`, { 
      auth: true 
    }); 
    const { data } = apiResult;
    result.value = apiResult?.data;
    if (data) {
      emit('success');
    }
  } catch (err) {
    isLoading.value = false; 
    console.error('Error in responseListener:', err);
    handleError();
  }
};
  
onMounted(() => {
  GoogleAnalytics.popUpView({
    [EventParameter.POP_UP_NAME]: 'confirm_cancellation',
    [EventParameter.POP_UP_TITLE]: 'Are you sure you’d like to cancel this order?'
  });
});
  </script>
  